import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0,0,0,0.5)"}
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Confirmação", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "×", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Tem certeza que deseja continuar?")
], -1)
const _hoisted_9 = { class: "modal-footer" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "card-header pb-0" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Rotas")
], -1)
const _hoisted_12 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_13 = { class: "table-responsive p-0" }
const _hoisted_14 = { class: "table align-items-center mb-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Rota"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Veículo"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Motorista"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Serviços"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" }, "Distancia"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" }, "Fixa"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" }, "Confirmada"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" }, "Finalizada")
  ])
], -1)
const _hoisted_16 = { class: "d-flex px-2 py-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "ni ni-app" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  class: "align-middle text-center rota",
  style: {"display":"flex"}
}
const _hoisted_20 = { class: "stepper" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { style: {"font-size":"8px"} }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "align-middle text-center" }
const _hoisted_28 = { class: "text-secondary text-xs font-weight-bold" }
const _hoisted_29 = { class: "align-middle text-center" }
const _hoisted_30 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "text-xs font-weight-bold mb-0" }
const _hoisted_33 = { class: "align-middle text-center text-sm" }
const _hoisted_34 = { class: "badge badge-sm bg-gradient-success" }
const _hoisted_35 = {
  key: 0,
  class: "fab fa-google text-secondary text-xs"
}
const _hoisted_36 = {
  key: 1,
  class: "fab fa-product-hunt text-secondary"
}
const _hoisted_37 = { class: "align-middle text-center text-sm" }
const _hoisted_38 = { class: "form-check form-switch" }
const _hoisted_39 = ["onChange", "onUpdate:modelValue"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, null, -1)
const _hoisted_41 = { class: "align-middle text-center text-sm" }
const _hoisted_42 = {
  key: 0,
  class: "form-check form-switch"
}
const _hoisted_43 = ["onChange", "onUpdate:modelValue"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, null, -1)
const _hoisted_45 = {
  key: 1,
  class: "badge badge-lg bg-gradient-success"
}
const _hoisted_46 = { class: "align-middle text-center text-sm" }
const _hoisted_47 = { class: "form-check form-switch" }
const _hoisted_48 = ["onChange", "onUpdate:modelValue"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, null, -1)
const _hoisted_50 = { class: "text-sm" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-eye text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_57 = [
  _hoisted_56
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($data.showConfirmModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.showConfirmModal = false))
                }, _hoisted_7)
              ]),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.showConfirmModal = false))
                }, "Cancelar"),
                _createElementVNode("button", {
                  class: "btn btn-danger",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmAction && _ctx.confirmAction(...args)))
                }, "Confirmar")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("table", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.rotas, (rota) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", {
                          class: "align-items-center badge badge-sm",
                          style: _normalizeStyle({ backgroundColor: rota.color, opacity: 0.5, width: '25px' })
                        }, _hoisted_18, 4),
                        _createElementVNode("div", null, _toDisplayString(rota.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", {
                            class: "step icon",
                            style: _normalizeStyle({ backgroundColor: rota.color,  opacity: 0.5})
                          }, _hoisted_22, 4),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rota.Pedidos, (pedido, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: pedido.ordem,
                              onClick: ($event: any) => ($setup.setCenterItem(pedido)),
                              class: _normalizeClass(['step', $setup.getClassByStatus(pedido.status_entrega),  pedido === 'Intervalo' ? 'interval' : ''])
                            }, [
                              _createElementVNode("span", _hoisted_24, _toDisplayString(pedido.numero_pedido), 1)
                            ], 10, _hoisted_23))
                          }), 128)),
                          _createElementVNode("div", {
                            class: "step icon",
                            style: _normalizeStyle({ backgroundColor: rota.color,  opacity: 0.5})
                          }, _hoisted_26, 4)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(rota.Veiculo.marca+ " " +rota.Veiculo.modelo), 1)
                  ]),
                  _createElementVNode("td", _hoisted_29, [
                    (!rota.operador_id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, " SEM MOTORISTA "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(rota.operador?.nome_completo), 1))
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(rota.Pedidos.length), 1)
                  ]),
                  _createElementVNode("td", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, _toDisplayString(rota.distance) + " Km ", 1),
                    (rota.modo =='GOOGLE')
                      ? (_openBlock(), _createElementBlock("i", _hoisted_35))
                      : (_openBlock(), _createElementBlock("i", _hoisted_36))
                  ]),
                  _createElementVNode("td", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "flexSwitchCheckDefault",
                        onChange: ($event: any) => ($setup.salvarRota(rota)),
                        "onUpdate:modelValue": ($event: any) => ((rota.fixa) = $event)
                      }, null, 40, _hoisted_39), [
                        [_vModelCheckbox, rota.fixa]
                      ]),
                      _hoisted_40
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_41, [
                    (!rota.confirmada)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: "flexSwitchCheckDefault",
                            onChange: ($event: any) => ($setup.salvarRota(rota)),
                            "onUpdate:modelValue": ($event: any) => ((rota.confirmada) = $event)
                          }, null, 40, _hoisted_43), [
                            [_vModelCheckbox, rota.confirmada]
                          ]),
                          _hoisted_44
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_45, "CONFIRMADA"))
                  ]),
                  _createElementVNode("td", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "flexSwitchCheckDefault",
                        onChange: ($event: any) => ($setup.salvarRota(rota)),
                        "onUpdate:modelValue": ($event: any) => ((rota.finalizado) = $event)
                      }, null, 40, _hoisted_48), [
                        [_vModelCheckbox, rota.finalizado]
                      ]),
                      _hoisted_49
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_50, [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: ($event: any) => ($setup.toggleRoute(rota)),
                      "data-bs-toggle": "tooltip",
                      "data-bs-original-title": "Preview product"
                    }, _hoisted_53, 8, _hoisted_51),
                    _hoisted_54,
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: ($event: any) => ($setup.removerRota(rota)),
                      "data-bs-toggle": "tooltip",
                      "data-bs-original-title": "Delete product"
                    }, _hoisted_57, 8, _hoisted_55)
                  ])
                ]))
              }), 256))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}